<template>
  <div class="cursor-pointer">
    <VTabs :tabs="tabs.tabs" :isGrow="true" @change="tabsOnChange" class="mb-1" />
    <div style="height:90vh" class="overflow-y-auto">
      <div v-if="tabs.isSelected('Comp')" class>
        <div
          class="hover:bg-blue-600 hover:text-white px-1 p-1 text-xs flex items-center"
          :class="[isSelectedComponent(item) ? 'bg-blue-600 text-white':  'text-gray-600']"
          v-for="item of components"
          :key="item.id"
          @click="selectComponent({component:item})"
        >
          <div>
            <LayoutIcon size="12" class="mr-1" />
          </div>
          <div class="flex-grow truncate">{{item.name}}</div>
          <div @click="deleteComponent(item)">
            <Trash2Icon size="12" />
          </div>
        </div>
      </div>
      <div v-else class="flex flex-wrap justify-center h-full overflow-scroll">
        <input
          class="form-control w-24"
          placeholder="Search Icon"
          @keydown="(event)=>onFilter(event.target.value)"
        />
        <div
          tabindex="1"
          v-for="(icon,i) of filteredIcons"
          :key="i"
          class="w-8 h-8 rounded-full text-center text-gray-300 hover:text-blue-400 hover:shadow hover:bg-gray-800 flex active:bg-gray-600 items-center outline-none"
          @click="onAddIcon({tool:'icon', icon})"
        >
          <div class="m-auto">
            <i :data-feather="icon"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { UiTabs } from "../util";
import feather from "./../util/vendors/feather.min";

export default {
  name: "Toolbar",
  props: {},
  data() {
    return {
      tabs: new UiTabs(["Comp",
      "Icons"
      ]),
      searchValue: "",
      filteredIcons: []
    };
  },
  mounted() {
    // this.selectedTool('rect');
    this.filteredIcons = this.featherIcons;
  },
  computed: {
    ...mapGetters([
      "tools",
      "selectedTool",
      "isPreview",
      "isSync",
      "selectedComponent",
      "components",
      "isSelectedComponent",
      "featherIcons"
    ])
  },
  methods: {
    ...mapActions([
      "selectTool",
      "preview",
      "sync",
      "editComponent",
      "deleteComponent",
      "selectComponent",
      "addIcon"
    ]),
    tabsOnChange(item) {
      this.tabs.select(item);
      this.$nextTick().then(resp => {
        feather.replace();
        this.$mount();
      });
    },
    onAddIcon(payload) {
      this.addIcon(payload).then(resp => {
        this.$mount();
        this.$nextTick().then(() => {
          feather.replace();
          this.$mount();
        });
      });
    },
    onFilter(value) {
      const res = this.featherIcons.filter(item => item.includes(value));
      this.filteredIcons = value ? res : this.featherIcons;
      this.$mount();
      this.$nextTick(() => {
        feather.replace();
        this.$mount();
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.anim {
  animation: up 2s infinite;
}
@keyframes up {
  from {
    transform: translateY(4px);
  }
  to {
    transform: translateY(-4px);
  }
}
</style>
